var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 1H9.8C8.81 1 8 1.81 8 2.8V17.2C8 18.19 8.81 18.99 9.8 18.99L18.2 19C19.19 19 20 18.19 20 17.2V2.8C20 1.81 19.19 1 18.2 1ZM14 3C15.1 3 16 3.89 16 5C16 6.11 15.1 7 14 7C12.9 7 12 6.11 12 5C12 3.89 12.9 3 14 3ZM14 16.5C11.79 16.5 10 14.71 10 12.5C10 10.29 11.79 8.5 14 8.5C16.21 8.5 18 10.29 18 12.5C18 14.71 16.21 16.5 14 16.5Z",
    fill: "#C4C5D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15C15.3807 15 16.5 13.8807 16.5 12.5C16.5 11.1193 15.3807 10 14 10C12.6193 10 11.5 11.1193 11.5 12.5C11.5 13.8807 12.6193 15 14 15Z",
    fill: "#C4C5D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5H4V21C4 22.1 4.89 23 6 23H16V21H6V5Z",
    fill: "#C4C5D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockIcon);
export default __webpack_public_path__ + "static/media/StockIcon.2237b04d0c5d19bfb4a4f57d82de5ac2.svg";
export { ForwardRef as ReactComponent };